import request from '@/utils/request'
export function netRank(data) {
  return request({
    url: 'web/intimacy/networkWeekTop',
    method: 'get',
    data
  })
}
export function myNetRank(data) {
  return request({
    url: 'web/intimacy/networkRank',
    method: 'get',
    data
  })
}